module.exports = __webpack_public_path__ + "d13dbdcd42a10ec2f76aff10d3554bc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-stores/google-play.svg
// module id = 2175
// module chunks = 0 1 2